import { Button, Card, CardBody, CardDescription, CardHeader, CardTitle, Chip } from '@studio/ui';
import { useState } from 'react';
import { AppShell } from '../components/AppShell';
import { BrandDnaModal } from '../components/BrandDnaModal';

interface Platform {
  id: 'wix' | 'etsy' | 'ebay' | 'shopify';
  name: string;
  blurb: string;
  status: 'available' | 'soon';
}

const PLATFORMS: Platform[] = [
  {
    id: 'wix',
    name: 'Wix',
    blurb:
      'Import the catalog from your Wix store and push generated images back to product galleries.',
    status: 'soon',
  },
  {
    id: 'etsy',
    name: 'Etsy',
    blurb: 'Pull listings, refresh hero shots, generate lifestyle scenes for handmade goods.',
    status: 'soon',
  },
  {
    id: 'ebay',
    name: 'eBay',
    blurb: 'Sync active listings and lift photos with auto-enhanced backgrounds.',
    status: 'soon',
  },
  {
    id: 'shopify',
    name: 'Shopify',
    blurb: 'Connect a Shopify store via the Admin API. Q3 target.',
    status: 'soon',
  },
];

export function ConnectionsPage() {
  const [brandOpen, setBrandOpen] = useState(false);

  return (
    <AppShell activeTab="connections" onOpenBrand={() => setBrandOpen(true)}>
      <header className="mb-8">
        <p className="eyebrow mb-2">Surface 3 · Sources</p>
        <h1 className="display text-display-xl">Connect your platforms</h1>
        <p className="mt-1 max-w-xl text-sm text-fg-3">
          Studio reads from these to keep your catalog in sync. OAuth flows go live as each adapter
          ships.
        </p>
      </header>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {PLATFORMS.map((platform) => (
          <Card key={platform.id} className="overflow-hidden">
            <CardHeader>
              <div className="flex items-start justify-between gap-3">
                <CardTitle className="text-base">{platform.name}</CardTitle>
                <Chip
                  size="xs"
                  variant={platform.status === 'soon' ? 'soft' : 'solid'}
                  tone={platform.status === 'soon' ? 'neutral' : 'accent'}
                >
                  {platform.status === 'soon' ? 'Coming soon' : 'Available'}
                </Chip>
              </div>
              <CardDescription className="text-xs text-fg-3">{platform.blurb}</CardDescription>
            </CardHeader>
            <CardBody className="pt-0">
              <Button
                variant="secondary"
                size="sm"
                disabled
                aria-label={`Connect ${platform.name}`}
              >
                Connect
              </Button>
            </CardBody>
          </Card>
        ))}
      </div>

      <BrandDnaModal open={brandOpen} onOpenChange={setBrandOpen} />
    </AppShell>
  );
}
